module.exports = __webpack_public_path__ + "img/map-pin.6dd06a72.svg";